import {Component, Injectable, OnInit} from '@angular/core';
import {ThemePalette} from "@angular/material/core";
import {ProgressSpinnerMode} from "@angular/material/progress-spinner";
import {Observable, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {NavigationStart, Router} from "@angular/router";
import {filter} from "rxjs/operators";

declare function loadingFrame(): any;
@Component({
    selector: 'app-loading-frame',
    templateUrl: './loading-frame.component.html',
    styleUrls: ['./loading-frame.component.scss'],
    standalone: false
})
export class LoadingFrameComponent implements OnInit {

  constructor(private loadingMaskService: LoadingMaskServiceService, private router: Router) {
    this.loadingInProcess = true;
    this.initVariables();
  }

  color: ThemePalette = 'warn';
  mode: ProgressSpinnerMode = 'indeterminate';
  value = 50;
  showMask!: boolean;
  customMaskText!: string;
  private unsubscribe$!: Subject<void>;
  defaultMaskText!: string;
  loadingInProcess: boolean;

  ngOnInit(): void {
    loadingFrame()
  }

  private initVariables(): void {
    this.unsubscribe$ = new Subject<void>();

    this.loadingMaskService.getOnLoadingMask().pipe(takeUntil(this.unsubscribe$)).subscribe(data => {
      this.showMask = data.showMask;
      if(!this.showMask) {
        this.setDefaultMaskText();
      }
    });

    this.loadingMaskService.getOnCustomMaskText().pipe(takeUntil(this.unsubscribe$)).subscribe(customText => {
      this.setCustomizedMaskText(customText);
    });

    this.router.events.pipe(
      filter(event => event instanceof NavigationStart),
      takeUntil(this.unsubscribe$)
    ).subscribe(() => this.loadingMaskService.reset());
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  setCustomizedMaskText(customText: string) {
    this.customMaskText = customText;
  }

  setDefaultMaskText() {
    this.customMaskText = this.defaultMaskText;
  }

}

interface LoadingData {
  showMask: boolean;
  showLoading: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class LoadingMaskServiceService {
  constructor() { }
  private readonly maximumMaskDurationMs = 10000;
  private loadingList:boolean[] = [];
  private onLoadingMask$ = new Subject<any>();
  private onCustomMaskText$ = new Subject<string>();
  private maskTimeout?: ReturnType<typeof setTimeout>;

  setOnLoadingMask(showLoading: boolean, showMask: boolean) {
    if(showLoading == true && showMask ==true){
      if (this.loadingList.length === 0) {
        this.startMaskTimeout();
      }
      this.loadingList.push(true);
    }
    if(showLoading == false && showMask == false){
      this.loadingList.pop();
    }
    const data: LoadingData = {
      showMask: showMask,
      showLoading: showLoading,
    }
    if(this.loadingList.length == 0){
      this.clearMaskTimeout();
      setTimeout(()=>this.onLoadingMask$.next({
        showMask: false,
        showLoading: false,
      }),200)

    }else{
      this.onLoadingMask$.next({
        showMask: true,
        showLoading: true,
      })
    }
    // if(showLoading == false && showMask == false){
    //   this.loadingList.pop();
    //   if(this.loadingList.length == 0){
    //     alert("hello world")
    //     this.onLoadingMask$.next({
    //       showMask: false,
    //       showLoading: false,
    //     });
    //   } else{
    //     this.onLoadingMask$.next({
    //       showMask: true,
    //       showLoading: true,
    //     });
    //   }
    // }

    // this.onLoadingMask$.next(data);
  }

  setOnCustomMaskText(customText: string) {
    this.onCustomMaskText$.next(customText);
  }

  getOnCustomMaskText(): Observable<string> {
    return this.onCustomMaskText$.asObservable();
  }

  getOnLoadingMask(): Observable<LoadingData> {
    return this.onLoadingMask$.asObservable();
  }

  reset(): void {
    this.clearMaskTimeout();
    this.loadingList = [];
    this.onLoadingMask$.next({ showMask: false, showLoading: false });
  }

  private startMaskTimeout(): void {
    this.clearMaskTimeout();
    this.maskTimeout = setTimeout(() => this.reset(), this.maximumMaskDurationMs);
  }

  private clearMaskTimeout(): void {
    if (this.maskTimeout) {
      clearTimeout(this.maskTimeout);
      this.maskTimeout = undefined;
    }
  }
}
